/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesharetext2Inputs */



/**
* | output |
* | --- |
* | "I described you in one word — 🫢🫣🤫. Come see what it is: Add me on Luni. It's a new way to expand your circle with AI" |
*
* @param {Invitesharetext2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesharetext2 = /** @type {((inputs?: Invitesharetext2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesharetext2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("I described you in one word — 🫢🫣🤫. Come see what it is:\n\nAdd me on Luni. It's a new way to expand your circle with AI\n\n")
	if (locale === "es") return /** @type {LocalizedString} */ ("Te describí en una palabra: 🫢🫣🤫. Ven a ver cuál es:\n\nAñádeme en Luni. Es una nueva forma de ampliar tu círculo con IA\n\n")
	return /** @type {LocalizedString} */ ("Я назвал тебя одним словом — 🫢🫣🤫. Зайди и посмотри, каким:\n\nДобавляйся ко мне в Луни. Это новая тема для расширения круга с помощью ИИ\n\n")
});
export { invitesharetext2 as "inviteShareText" }